import React from "react";
import { FormattedErrorMessage } from "../../formatter/types";
// import ReactMarkdown from "react-markdown";

interface ErrorMessageProps {
  error?: FormattedErrorMessage | string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Component to display formatted error messages
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  className = "reform-error",
  showIcon = true,
}) => {
  if (!error) return null;

  // Handle string errors (backward compatibility)
  if (typeof error === "string") {
    return (
      <div className={className}>
        {showIcon && <span className="reform-error-icon">⚠️</span>}
        <span>{error}</span>
      </div>
    );
  }

  const { content, format, meta } = error;

  // Handle different formats
  switch (format) {
    case "jsx":
      return (
        <div className={className} data-error-meta={JSON.stringify(meta || {})}>
          {content}
        </div>
      );

    case "html":
      return (
        <div
          className={className}
          data-error-meta={JSON.stringify(meta || {})}
          dangerouslySetInnerHTML={{ __html: content as string }}
        />
      );

    case "markdown":
      return (
        <div className={className} data-error-meta={JSON.stringify(meta || {})}>
          {/* <ReactMarkdown>{content as string}</ReactMarkdown> */}
          <span>{content as string}</span>
        </div>
      );

    case "plain":
    default:
      return (
        <div className={className} data-error-meta={JSON.stringify(meta || {})}>
          {showIcon && <span className="reform-error-icon">⚠️</span>}
          <span>{content}</span>
        </div>
      );
  }
};
